import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Blog = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const [monthFilter, setMonthFilter] = useState("");
  const monthQuery = monthFilter ? `&month=${monthFilter}` : "";
  let is_alert = false;

  useEffect(() => {
    if (location.state !== null) {
      if (is_alert === false) {
        toast.success(location.state);
      }
      is_alert = true;
    }
    window.history.replaceState({}, location.state);
  }, []);

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [showAutherImagesModal, setShowAutherImagesModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const BlogData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/blog?page=${page}&limit=10&search=${search}${monthQuery}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        const response = res?.data?.data;
        setTotalPage(response?.pagination?.totalPages);
        const blogdata = response?.blogs.filter(
          (item) => item.title !== null && item.imagepath !== null
        );
        setData(blogdata);
      })
      .catch((err) => {
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(fileData, "blog.xlsx");
  };

  const HandleActiveDeactive = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === true) {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .post(
            `${process.env.REACT_APP_URL}/admin/blog/toggle-status/${id}`,
            {
              id: id,
              status: status ? false : true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.message);
              BlogData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err.response.status) ||
              MSG.includes(err.response.data.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              // toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  const HandleDelete = (id) => {
    Swal.fire({
      title: "Do you want to Delete this Record?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#DC3741",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .delete(`${process.env.REACT_APP_URL}/admin/blog/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              Swal.fire({
                title: "Deleted Sucessfully.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
              });
              BlogData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err.response.status) ||
              MSG.includes(err.response.data.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  useEffect(() => {
    BlogData();
  }, [page, search, monthFilter]);

  const IMG = (p) => `${process.env.REACT_APP_IMAGE_URL}/uploads/${p}`;
  const initialsOf = (name = "") =>
    name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  const TINTS = [
    { bg: "var(--color-info-bg)", color: "var(--color-info-text)" },
    { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    { bg: "var(--color-violet-bg)", color: "var(--color-violet-text)" },
    { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
  ];
  const tint = (s = "") => TINTS[(String(s).length) % TINTS.length];
  const fmt = (d) =>
    d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }) : "—";

  const [dense, setDense] = useState(false);
  const [sortDir, setSortDir] = useState("");

  let displayData = [...(data || [])];
  if (sortDir) {
    displayData.sort((a, b) => {
      const av = (a?.title || "").toLowerCase();
      const bv = (b?.title || "").toLowerCase();
      if (av < bv) return sortDir === "asc" ? -1 : 1;
      if (av > bv) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
  }

  const Toggle = ({ item }) => (
    <button type="button" className={`al-toggle ${item.is_active ? "is-on" : ""}`}
      title={item.is_active ? "Deactivate" : "Activate"}
      onClick={() => HandleActiveDeactive(item.blog_id, item.is_active)}>
      <span className="al-toggle__knob" />
    </button>
  );

  const RowActions = ({ item }) => (
    <div className="al-actions">
      <button type="button" className="al-act" title="View"
        onClick={() =>
          Navigate("/admin/blog/show", {
            state: {
              id: item?.blog_id, name: item?.title, size: item?.size,
              material_color: item?.material_color, burst_factor: item?.burst_factor,
              print_coverage: item?.print_coverage, status: item?.is_active,
              additional_fields: item?.additional_fields,
            },
          })
        }>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      </button>
      <button type="button" className="al-act al-act--primary" title="Edit"
        onClick={() => Navigate("/admin/blog/edit", { state: { id: item?.blog_id } })}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>
      </button>
      <button type="button" className="al-act al-act--danger" title="Delete"
        onClick={() => HandleDelete(item?.blog_id)}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
      </button>
    </div>
  );

  const GRID = { gridTemplateColumns: "52px 1.8fr 1fr 1fr .8fr 1fr 118px" };

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Blog</h1>
          <p className="al-sub">Articles and insights published on the marketplace.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={exportToExcel}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Export
          </button>
          <button type="button" className="al-btn al-btn--primary" onClick={() => Navigate("/admin/blog/add")}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Blog
          </button>
        </div>
      </div>

      <div className="al-card">
        <div className="al-toolbar">
          <div className="al-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-tertiary)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <input type="search" placeholder="Search posts by title…"
              onKeyDown={(e) => e.key === "Enter" && search !== "" && BlogData()}
              onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="al-select">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <select value={monthFilter} onChange={(e) => setMonthFilter(e.target.value)}>
              <option value="">Select Month</option>
              <option value="All">All</option>
              <option value="1">Last 1 Month</option>
              <option value="3">Last 3 Months</option>
              <option value="6">Last 6 Months</option>
            </select>
          </div>
          <button type="button" className="al-tool" style={{ marginLeft: "auto" }} onClick={() => setDense((d) => !d)} title="Toggle density">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            {dense ? "Comfortable" : "Density"}
          </button>
        </div>

        <div className="al-tablewrap">
          <div style={{ minWidth: 980, "--al-row-pad": dense ? "8px" : "13px" }}>
            <div className="al-thead" style={GRID}>
              <span className="al-th">Image</span>
              <span className="al-th al-th--sort" onClick={() => setSortDir((d) => (d === "asc" ? "desc" : d === "desc" ? "" : "asc"))}>
                Title
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: sortDir ? 1 : 0.45, transform: sortDir === "desc" ? "rotate(180deg)" : "none" }}><polyline points="18 15 12 9 6 15"/></svg>
              </span>
              <span className="al-th">Category</span>
              <span className="al-th">Author</span>
              <span className="al-th">Is Active</span>
              <span className="al-th">Date</span>
              <span className="al-th al-th--right">Action</span>
            </div>

            {displayData && displayData.length > 0 ? (
              displayData.map((item) => {
                const ct = tint(item?.category);
                const at = tint(item?.author_name);
                return (
                  <div className="al-row" style={GRID} key={item.blog_id}>
                    <button type="button" className="al-thumb" title="View image" style={{ cursor: "pointer" }}
                      onClick={() => { setSelectedImage(item?.image_path ? IMG(item.image_path) : null); setShowImagesModal(true); }}>
                      {item?.image_path ? (
                        <img src={IMG(item.image_path)} alt="" />
                      ) : (
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                      )}
                    </button>
                    <span className="al-name">{item?.title}</span>
                    <span>
                      {item?.category ? (
                        <span className="al-pill" style={{ background: ct.bg, color: ct.color }}>{item.category}</span>
                      ) : <span className="al-muted">—</span>}
                    </span>
                    <div className="al-id">
                      <button type="button" className="al-avatar" title="View author image"
                        style={{ background: at.bg, color: at.color, border: 0, cursor: "pointer", overflow: "hidden", padding: 0 }}
                        onClick={() => { setSelectedImage(item?.author_image ? IMG(item.author_image) : null); setShowAutherImagesModal(true); }}>
                        {item?.author_image ? <img src={IMG(item.author_image)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : initialsOf(item?.author_name)}
                      </button>
                      <span className="al-name" style={{ fontWeight: 600 }}>{item?.author_name || "—"}</span>
                    </div>
                    <span><Toggle item={item} /></span>
                    <span className="al-mono al-muted">{fmt(item?.created_at)}</span>
                    <RowActions item={item} />
                  </div>
                );
              })
            ) : (
              <div className="al-empty">
                <div className="al-empty__icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                </div>
                <p className="al-empty__title">No Blogs Found</p>
                <p className="al-empty__text">Try a different search or add a blog.</p>
              </div>
            )}
          </div>
        </div>

        <div className="al-foot">
          <span className="al-foot__info">Showing <strong>{displayData?.length || 0}</strong> posts</span>
          {data && data.length !== 0 && (
            <ReactPaginate
              previousLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>}
              nextLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>}
              breakLabel={"..."}
              pageCount={totalpage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end m-0"}
              pageClassName={"page-item"} pageLinkClassName={"page-link"}
              previousClassName={"page-item"} previousLinkClassName={"page-link"}
              nextClassName={"page-item"} nextLinkClassName={"page-link"}
              breakClassName={"page-item"} breakLinkClassName={"page-link"}
              activeClassName={"active"} />
          )}
        </div>
      </div>

      {(showImagesModal || showAutherImagesModal) && (
        <div className="al-modal" onClick={() => { setShowImagesModal(false); setShowAutherImagesModal(false); }}>
          <div className="al-modal__scrim" />
          <div className="al-modal__box" onClick={(e) => e.stopPropagation()} style={{ width: "min(360px,92vw)" }}>
            <div className="al-modal__head">
              <h3 className="al-modal__title">Image Preview</h3>
              <button type="button" className="al-act" onClick={() => { setShowImagesModal(false); setShowAutherImagesModal(false); }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding: 20, display: "flex", justifyContent: "center" }}>
              {selectedImage ? (
                <img src={selectedImage} alt="Preview" style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 12 }} />
              ) : (
                <p className="al-muted">No image available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Blog;
